"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _SelectMetadataForm = require("../SelectMetadataForm");
var _StepTwoFileItem = _interopRequireDefault(require("./StepTwoFileItem"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var StepTwo = function StepTwo(_ref) {
  var files = _ref.files,
    callbackSetMessage = _ref.callbackSetMessage,
    callbackSetFiles = _ref.callbackSetFiles,
    currentFile = _ref.currentFile;
  var _useState = (0, _react.useState)(files),
    _useState2 = _slicedToArray(_useState, 2),
    internalFiles = _useState2[0],
    setInternalFiles = _useState2[1];
  var prevIsCompletedRef = (0, _react.useRef)(0);
  (0, _react.useEffect)(function () {
    callbackSetFiles(internalFiles);
    var isCompletedLength = internalFiles.filter(function (f) {
      return f.isCompleted;
    }).length;
    if (isCompletedLength > (prevIsCompletedRef === null || prevIsCompletedRef === void 0 ? void 0 : prevIsCompletedRef.current)) {
      prevIsCompletedRef.current = isCompletedLength;
      callbackSetMessage("(".concat(isCompletedLength, "/").concat(internalFiles.length, ") Document details are saved"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [internalFiles]);
  var getFieldValue = function getFieldValue(fieldName) {
    var selectedInternalFiles = internalFiles.filter(function (file) {
      return file.isChecked;
    });
    return selectedInternalFiles.length > 0 && selectedInternalFiles.every(function (file) {
      return file[fieldName] === selectedInternalFiles[0][fieldName];
    }) ? selectedInternalFiles[0][fieldName] : "";
  };
  var fileCategoryValue = getFieldValue("fileCategory");
  var metadataValue = getFieldValue("metadata");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid-files-details",
    "data-testid": "stepTwo"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selected-files flex flow-column"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: "16px"
    },
    className: "title"
  }, "Selected files"), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontSize: "14px",
      marginTop: "10px"
    }
  }, "Select an attachement to input details."), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    label: "Select All",
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      checked: internalFiles.every(function (file) {
        return file.isChecked;
      }),
      indeterminate: internalFiles.some(function (file) {
        return file.isChecked;
      }) && !internalFiles.every(function (file) {
        return file.isChecked;
      }),
      onChange: function onChange(_, checked) {
        setInternalFiles(internalFiles.map(function (file) {
          return _objectSpread(_objectSpread({}, file), {}, {
            isChecked: checked
          });
        }));
      }
    }),
    sx: {
      paddingLeft: "10px"
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.Divider, {
    component: "div"
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: "flex",
      flexDirection: "column",
      paddingLeft: "10px",
      overflowX: "auto",
      height: "calc(65vh - 266px)"
    }
  }, internalFiles === null || internalFiles === void 0 ? void 0 : internalFiles.map(function (file, index) {
    return /*#__PURE__*/_react["default"].createElement(_StepTwoFileItem["default"], {
      key: "fileItem-".concat(index, "-").concat(file.file.name),
      file: file,
      index: index,
      setInternalFiles: setInternalFiles,
      currentFile: currentFile
    });
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "separator"
  }), /*#__PURE__*/_react["default"].createElement(_SelectMetadataForm.SelectMetadataForm, {
    internalFiles: internalFiles,
    fileCategoryValue: fileCategoryValue,
    setInternalFiles: setInternalFiles,
    metadataValue: metadataValue
  }));
};
var _default = exports["default"] = StepTwo;